import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import GoodReceivedNotes from './GoodReceivedNotes';
import './GoodReceivedNotes.less';

export const prefix = 'bm-p-good-received-notes';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: GoodReceivedNotes,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
